var _style, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEnrich(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20",
    width: 22,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-enrich") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m4 4.5c0.2 0.2 0.2 0.5 0.1 0.7-0.2 0.2-0.5 0.2-0.7 0.1l-1.9-1.6q0 0 0 0c-0.2-0.2-0.3-0.5-0.1-0.7 0.2-0.2 0.5-0.2 0.7-0.1l1.9 1.6q0 0 0 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m1.4 11.7c-0.3 0-0.5-0.1-0.6-0.3-0.1-0.3 0-0.5 0.3-0.6l2.3-0.9q0 0 0 0c0.3-0.1 0.6 0.1 0.6 0.3 0.1 0.3 0 0.5-0.2 0.6l-2.4 0.9q0 0 0 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m21.1 17.7l-1.4 1.7c-0.2 0.2-0.5 0.3-0.7 0.1l-9.1-7.5c-0.2-0.2-0.2-0.5-0.1-0.7l1.5-1.7c0.1-0.2 0.4-0.2 0.6-0.1l9.2 7.5c0.2 0.2 0.2 0.4 0 0.7zm-1.8 0.8l0.8-1.1-8.4-6.9-0.9 1.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m8.3 16c0 0.2-0.2 0.4-0.5 0.4-0.2 0-0.5-0.2-0.5-0.4v-2.6c0-0.3 0.2-0.5 0.5-0.5 0.3 0 0.5 0.2 0.5 0.5v2.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m9 3.4c0 0.3-0.2 0.5-0.5 0.5-0.3 0-0.5-0.2-0.5-0.5v-2.5c0-0.3 0.2-0.5 0.5-0.5 0.2 0 0.4 0.2 0.4 0.5l0.1 2.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m12.8 6.9c-0.3 0.1-0.5 0-0.6-0.3-0.1-0.2 0-0.5 0.3-0.6l2.4-0.8q0 0 0 0c0.2-0.1 0.5 0 0.6 0.3 0 0.2-0.1 0.5-0.3 0.6l-2.4 0.8q0 0 0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnrich);
export default __webpack_public_path__ + "static/media/icon-enrich.61931effd93ebec0d1e2eb3958a5872c.svg";
export { ForwardRef as ReactComponent };